import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function Footer() {
  const currentYear = new Date().getFullYear();
  const { userProfile } = useAuth();

  const isPromotor = userProfile?.role === 'promotor';

  return (
    <footer className="bg-black border-t border-zinc-900/80 text-zinc-400">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            {isPromotor ? (
              <h3 className="font-display font-black text-base text-white tracking-tight mb-4">F.A.C Autosport</h3>
            ) : (
              <div className="mb-4">
                <span className="font-display font-black text-sm sm:text-base text-white tracking-tight block leading-none">
                  JACKY CIRCUIT
                </span>
                <span className="font-mono text-[9px] uppercase tracking-[0.14em] text-zinc-500 mt-1 block">
                 
                </span>
              </div>
            )}
            <h4 className="text-sm font-semibold text-white mb-3">Contact Us</h4>
            <p className="text-sm leading-relaxed">
              Email: fac.autosportcuracao@outlook.com<br />
              Phone: +5999 5295684<br />
              Available 24/7
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-white mb-4">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/services" className="hover:text-primary-400 transition-colors">
                  Track Booking
                </Link>
              </li>
              <li>
                <Link to="/register" className="hover:text-primary-400 transition-colors">
                  Register
                </Link>
              </li>
              <li>
                <Link to="/login" className="hover:text-primary-400 transition-colors">
                  Login
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-white mb-4">Legal</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/privacy" className="hover:text-primary-400 transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="hover:text-primary-400 transition-colors">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/disclaimer" className="hover:text-primary-400 transition-colors">
                  Disclaimer
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-zinc-900/80 text-center text-xs text-zinc-600">
          <p>
            © {currentYear} {isPromotor ? 'F.A.C Autosport' : 'Jacky Circuit'}. All rights reserved. Design & development by MayBe
          </p>
        </div>
      </div>
    </footer>
  );
}
